// src/components/order/ModalViewReport.jsx
import { useState, useEffect } from "react";
import Modal from "../common/Modal";
import { getOrderReport } from "../../common/api/orders";
import { useToast } from "../../hooks/useToast";

function ModalViewReport({ order, onClose }) {
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(true);
  const toast = useToast();

  const tipoParteLabels = {
    "1": "Cambio de contador",
    "2": "Lectura cierres horarios (s02)",
    "3": "Lectura Monthly billing (s04)",
    "4": "Lectura cierres diarios (s05)",
    "5": "Lectura Meter parameters (s06)",
    "6": "Prime1.4 - Sagemcom"
  };

  useEffect(() => {
    const loadReport = async () => {
      try {
        setLoading(true);
        const data = await getOrderReport(order.COD_ID);
        
        // L'API restituisce un array con un oggetto
        if (data && data.length > 0 && data[0].ReportData) {
          setReportData(data[0].ReportData);
        } else {
          toast.error("El reporte no contiene datos");
        }
      } catch (err) {
        console.error("Error al cargar reporte:", err);
        toast.error(err.message || "Error al cargar el reporte");
      } finally {
        setLoading(false);
      }
    };

    loadReport();
  }, [order.COD_ID]);

  /*const handlePrint = () => {
    const printWindow = window.open('', '_blank');
    const reportContent = reportData.join('\n');
    
    printWindow.document.write(`
      <html>
        <head>
          <title>Reporte Parte ${order.COD_ID}</title>
          <style>
            body { font-family: 'Courier New', monospace; padding: 20px; }
            pre { white-space: pre-wrap; word-wrap: break-word; }
          </style>
        </head>
        <body>
          <h2>Reporte Parte de Trabajo</h2>
          <p><strong>Tipo:</strong> ${tipoParteLabels[order.TipoParte] || order.TipoParte}</p>
          <p><strong>CUPS:</strong> ${order.CUPS}</p>
          <p><strong>CntId:</strong> ${order.CntId}</p>
          <hr>
          <pre>${reportContent}</pre>
        </body>
      </html>
    `);
    
    printWindow.document.close();
    printWindow.print();
  };
*/
const handlePrint = () => {
  const printWindow = window.open('', '_blank');

  // Funzione per eseguire l’escape dei caratteri speciali HTML
  const escapeHtml = (unsafe) => {
    return unsafe
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  };

  // Converti il contenuto in testo sicuro
  const reportContent = escapeHtml(reportData.join('\n'));

  printWindow.document.write(`
    <html>
      <head>
        <title>Reporte Parte ${order.COD_ID}</title>
        <style>
          body { font-family: 'Courier New', monospace; padding: 20px; }
          pre { white-space: pre-wrap; word-wrap: break-word; }
        </style>
      </head>
      <body>
        <h2>Reporte Parte de Trabajo</h2>
        <p><strong>Tipo:</strong> ${tipoParteLabels[order.TipoParte] || order.TipoParte}</p>
        <p><strong>CUPS:</strong> ${order.CUPS}</p>
        <p><strong>CntId:</strong> ${order.CntId}</p>
        <hr>
        <pre>${reportContent}</pre>
      </body>
    </html>
  `);

  printWindow.document.close();
  printWindow.print();
};

  const handleDownload = () => {
    const reportContent = reportData.join('\n');
    const blob = new Blob([reportContent], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `reporte_parte_${order.COD_ID}_${order.CUPS}.txt`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  return (
    <Modal title="Reporte del Parte" onClose={onClose} className="modal-large" position="top">
      {loading ? (
        <div className="input-group" style={{ textAlign: 'center', padding: '2rem' }}>
          <p>Cargando reporte...</p>
        </div>
      ) : (
        <>
          {/* Header con info del parte */}
          <div className="modal-content-scrollable" style={{ gap: '0.3rem' }}>
            {/* Header con info del parte */}
            <div className="input-group">
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1rem' }}>
                <div>
                  <label style={{ fontWeight: 'bold' }}>Tipo de parte:</label>
                  <div>{tipoParteLabels[order.TipoParte] || order.TipoParte}</div>
                </div>
                <div>
                  <label style={{ fontWeight: 'bold' }}>CUPS:</label>
                  <div>{order.CUPS}</div>
                </div>
                <div>
                  <label style={{ fontWeight: 'bold' }}>CntId:</label>
                  <div>{order.CntId}</div>
                </div>
                <div>
                  <label style={{ fontWeight: 'bold' }}>Dirección:</label>
                  <div>{order.DIRECCIONSUMINISTRO}</div>
                </div>
              </div>
            </div>

         {/* Report content */}
            <div className="input-group" style={{paddingTop: '0px'}}>
              <label style={{ fontWeight: 'bold' }}>Contenido del Reporte:</label>
              <div
                style={{
                  maxHeight: '40vh',
                  width: '100%',
                  overflowX: 'auto',
                  overflowY: 'auto',
                  border: '1px solid #ccc',
                  backgroundColor: '#f5f5f5',
                  // Propiedades para Firefox
                  scrollbarWidth: 'thin',
                  scrollbarColor: '#4a9eff #f5f5f5'
                }}
                // Estilos inline para WebKit (Chrome, Safari, Edge)
                className="custom-scrollbar"
              >
                <pre
                  style={{
                    fontFamily: "'Courier New', monospace",
                    fontSize: '0.9rem',
                    color: '#1a1a1a',
                    margin: 0,
                    whiteSpace: 'pre',
                    display: 'inline-block',
                    minWidth: '100%'
                  }}
                >
                  {reportData.join('\n')}
                </pre>
              </div>
            </div>
          </div>

          {/* Buttons */}
           <div className="input-group_row modal-actions">
            <span className="boton_opciones" onClick={handlePrint}>
              <i className="bi bi-printer"></i>&nbsp;Imprimir
            </span>
            <span className="boton_opciones" onClick={handleDownload}>
              <i className="bi bi-download"></i>&nbsp;Descargar TXT
            </span>
            <span className="boton_cancelar" onClick={onClose}>
              Cerrar
            </span>
          </div>
        </>
      )}
    </Modal>
  );
}

export default ModalViewReport;